import { render, staticRenderFns } from "./PopupFrame.vue?vue&type=template&id=a6bc5e4c&scoped=true&"
import script from "./PopupFrame.vue?vue&type=script&lang=js&"
export * from "./PopupFrame.vue?vue&type=script&lang=js&"
import style0 from "./PopupFrame.vue?vue&type=style&index=0&id=a6bc5e4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6bc5e4c",
  null
  
)

export default component.exports